import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAddresses, removeAddress, setMainAddress } from '../../redux/actions';
import { addNotification } from '../../redux/actions';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import AddressDialog from '../../components/AddressDialog';
import AddressCard from '../../components/AddressCard';
import { setLoadingCheckoutAddress } from '../../redux/actions';
import { Button } from 'antd';

export function ViewOtherAddressItem({ address }) {
  // eslint-disable-next-line no-unused-vars
  const [open, setOpen] = useState(false);
  return (
    <Grid item xs={12} md={6}>
      <Button onClick={() => setOpen(true)}>Crear</Button>
    </Grid>
  );
}

export function ViewAddressItem({ address }) {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  function setMain() {
    dispatch(setMainAddress(address.id));
  }

  function remove() {
    dispatch(removeAddress(address.id)).then(() => {
      dispatch(setLoadingCheckoutAddress(true));
      dispatch(getAddresses())
        .then(() => {
          dispatch(setLoadingCheckoutAddress(false));
        })
        .catch(() => {
          dispatch(setLoadingCheckoutAddress(false));
        });
      dispatch(addNotification('Dirección eliminada', 'success'));
    });
  }

  return (
    <Grid item xs={12} md={6}>
      <Box mb={2}>
        <AddressDialog
          currentEditAddress={address}
          handleClose={() => setOpen(false)}
          open={open}
        />
        <AddressCard
          handleChangeMain={setMain}
          deleteAddress={remove}
          editAddress={() => setOpen(true)}
          item={address}
        />
      </Box>
    </Grid>
  );
}
